import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { 
  Home, 
  Users, 
  Calendar, 
  Video, 
  FileText, 
  Settings, 
  LogOut,
  User,
  Bell
} from 'lucide-react';
import { authService } from '../../../modules/auth/services/authService';

const PatientAdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = authService.getCurrentUser();

  const handleLogout = () => {
    authService.logoutToRoleSelection();
  };

  return (
    <div className="min-h-screen bg-gray-50" style={{ zoom: '90%' }}>
      {/* Header */}
      <div className="bg-white shadow-sm">
        {/* Top Header - Logos and User */}
        <div className="flex justify-between items-center px-6 py-2">
          {/* MediFusion Logo - Left */}
          <img
            src="/login_medi_logo.png"
            alt="MediFusion"
            className="h-10 w-auto"
          />
          
          {/* User Name and GARLI MEDI TECH Logo - Right */}
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2 mr-10">
              <User className="h-5 w-5 text-blue-600" />
              <span className="text-sm font-medium text-gray-700">
                {localStorage.getItem('selectedRole') === 'doctor' && 'Dr. '}{currentUser?.first_name} {currentUser?.last_name}
              </span>
            </div>
            <img
              src="/garlimeditech.png"
              alt="GARLI MEDI TECH"
              className="h-8 w-auto"
            />
          </div>
        </div>

        {/* Navigation Bar */}
        <div className="border-t border-gray-200 px-6 py-2">
          <nav className="flex justify-end">
            <div className="flex items-center space-x-6">
              <Link
                to="/patient/dashboard"
                className={`text-sm font-medium transition-colors px-3 py-1 rounded-md ${
                  location.pathname === '/patient/dashboard'
                    ? 'bg-blue-600 text-white shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Home
              </Link>
              <Link
                to="/patient/admin"
                className={`text-sm font-medium transition-colors px-3 py-1 rounded-md ${
                  location.pathname.startsWith('/patient/admin')
                    ? 'bg-blue-600 text-white shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Admin
              </Link>
              <Link
                to="/patient/news"
                className={`text-sm font-medium transition-colors px-3 py-1 rounded-md ${
                  location.pathname === '/patient/news'
                    ? 'bg-blue-600 text-white shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                News
              </Link>
              <Link
                to="/patient/faqs"
                className={`text-sm font-medium transition-colors px-3 py-1 rounded-md ${
                  location.pathname === '/patient/faqs'
                    ? 'bg-blue-600 text-white shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                FAQs
              </Link>
              <button
                onClick={handleLogout}
                className="text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors"
              >
                Log Out
              </button>
            </div>
          </nav>
        </div>
      </div>

      {/* Page content - Full width for custom layout */}
      <main className="py-0">
        <Outlet />
      </main>
    </div>
  );
};

export default PatientAdminLayout; 